export default __webpack_public_path__ + "static/media/about002.94b5cd1e.jpg";